<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Почему ресторанам выгодно сотрудничество с агрегатором доставки еды</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <h2 class="text-block__text" style="margin-top:2%;">Что такое онлайн агрегатор доставки еды Хочу Поесть?</h2>
            <p class="text-block__text">Хочу Поесть — это онлайн агрегатор доставки еды, т. е. сервис, объединяющий в себе рестораны и кафе из разных городов с целью повышения их уровня продаж и обеспечения удобства выбора блюд и напитков пользователями.</p>
            <p class="text-block__text">Принцип работы Хочу Поесть прост: на сервисе пользователям предоставляется широкий спектр кафе и ресторанов по доставке готовой еды. Среди всех заведений человек выбирает интересное ему заведение и оформляет заказ.</p>
            <p class="text-block__text">Пользователи не платят за использование сервиса.</p>
            <p class="text-block__text">Рестораны отдают фиксированный процент от итоговой стоимости заказа агрегатору.</p>
            <p class="text-block__text">Что дает ресторану/ кафе сотрудничество с Хочу Поесть?</p>
            <p class="text-block__text"> - Увеличение прибыли за счет увеличения заказов.</p>
            <p class="text-block__text"> - Повышение узнаваемости заведения.</p>
            <p class="text-block__text"> - Постоянных покупателей, которые однажды обратившись к вам, будут дальше продолжать заказывать еду.</p>
            <p class="text-block__text"> - Дополнительные бесплатные рекламные компании (сервис проводит рекламу за свой счет).</p>
            <p class="text-block__text">- Дополнительная площадка для оформления заказа.</p>
              <h2 class="text-block__text" style="margin-top:2%;">Как начать сотрудничество с Хочу Поесть?</h2>
            <p class="text-block__text">Есть несколько способов начать сотрудничество с Хочу Поесть.
            <p class="text-block__text" style="margin-top: 10px;">1. <router-link to="/restaurants_services" target="_blank">Оставить заявку на сайте Хочу Поесть</router-link> и сотрудники свяжутся с Вами.</p>
            <p class="text-block__text" style="margin-top: 10px;">2. Написать на почту сотрудников службы подключения: <a href="mailto:m1@hochu-poest.com">m1@hochu-poest.com</a>, <a href="mailto:m2@hochu-poest.com">m2@hochu-poest.com</a></p>
            <p class="text-block__text" style="margin-top: 10px;">
              3. <a href="https://docs.google.com/forms/d/1CJxScQ01RK3B2NPDmOG6g1A0qYYroysXDp2KopX48NU/edit#responses" target="_blank">Заполнить гугл форму</a> на подключение ресторана к сервису.
            </p>
            <h2 class="text-block__text" style="margin-top:2%;">Актуальные вопросы</h2>
            <p class="text-block__text" style="margin-top: 10px;">1. Платно ли подключение к сервису?</p>
            <p class="text-block__text" style="margin-top: 5px;"> - Подключение, размещение и поддержка для ресторанов бесплатны.</p>
            <p class="text-block__text" style="margin-top: 10px;">2. Какой размер комиссии предусмотрен для ресторанов?</p>
            <p class="text-block__text" style="margin-top: 5px;"> - В среднем 10 % . Процент может быть снижен в индивидуальном порядке.</p>
            <p class="text-block__text" style="margin-top: 10px;">3. Как принимать заказы?</p>
            <p class="text-block__text" style="margin-top: 5px;"> - В личном кабинете, от которого Вам выдадут доступ.</p>
            <p class="text-block__text" style="margin-top: 10px;">4. Как узнать, что поступил заказ?</p>
            <p class="text-block__text" style="margin-top: 5px;"> - На номер телефона и почту придет оповещение?</p>
            <p class="text-block__text" style="margin-top: 10px;">5 Кто обновляет меню ?</p>
            <p class="text-block__text" style="margin-top: 5px;"> - Ресторан самостоятельно обновляет меню при необходимости или сообщает об изменениях менеджеру сопровождения.</p>
            <p class="text-block__text" style="margin-top: 10px;">6. За какие заказы платить комиссию?</p>
            <p class="text-block__text" style="margin-top: 5px;"> -За те, которые были получены через сервис Хочу Поесть.</p>
            <p class="text-block__text" style="margin-top: 10px;">7. В течении какого времени ресторан размещается на сервисе ?</p>
            <p class="text-block__text" style="margin-top: 5px;"> - В порядке очередности поступления заявок ( в среднем в течении 3 - х рабочих дней).</p>
            <p class="text-block__text" style="margin-top: 10px;">8. Есть ли курьеры в Хочу Поесть?</p>
            <p class="text-block__text" style="margin-top: 5px;"> - Нет.</p>
            <p class="text-block__text" style="margin-top: 10px;">9. Есть ли приложение Хочу Поесть?</p>
            <p class="text-block__text" style="margin-top: 5px;"> -Да, приложение доступно для скачивания в Google Play и Apps Store.</p>
            <p class="text-block__text" style="margin-top: 10px;">10. Можно ли подключиться к сервису без своей службы доставки?</p>
            <p class="text-block__text" style="margin-top: 5px;"> - Да, оформив ресторан с самовывозом заказов.</p>
              <router-link :to="'/product/2'" tag="div">
                <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
              </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'profit'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/profit.vue